"use client";
import * as React from "react";
import { Instagram, Facebook, PhoneCall } from "lucide-react";
import { IconBrandTiktok } from "@tabler/icons-react";


export default function Footer() {
  const services: [string, string][] = [
    ["Portfolio", "/portfolio"],
    ["About us", "/about"],
    ["Reviews", "/reviews"],
    ["Get a Free Quote", "/contact"],
  ];

  const about: [string, string][] = [
    ["Learn about us", "/about"],
    ["Instagram", "#"],
    ["Facebook", "#"],
    ["Tiktok", "#"],
  ];

  // Social links are index > 0 in the about array
  const socialIndexes = [1, 2, 3];

  function getSocialIcon(index: number) {
    if (index === 1) {
      return <Instagram className="h-4 w-4 text-foreground/70" />;
    }
    if (index === 2) {
      return <Facebook className="h-4 w-4 text-foreground/70" />;
    }
    if (index === 3) {
      return <IconBrandTiktok className="h-4 w-4 text-foreground/70" />;
    }
    return null;
  }

  return (
    <footer className="relative z-10 px-5 md:px-8 lg:px-0 pt-16 mb-2 pb-5 w-full">
      <div className="mx-auto flex w-full flex-col flex-wrap justify-start gap-6 lg:max-w-7xl lg:flex-row lg:flex-nowrap lg:justify-between lg:gap-20">
        {/* Logo */}
        <div className="w-full lg:w-1/3 lg:max-w-sm">
          <a href="/" className="mb-6 block w-fit">
            <img
              src="/images/logo.png"
              className="h-auto w-24"
            />
          </a>
          <p className="mb-8 text-foreground/80">
            Bishop Mercier delivers quality construction solutions for homes,
            businesses, and industries throughout Montreal.
          </p>
          <div className="flex items-center gap-3 text-sm text-foreground/80 transition-colors hover:text-primary cursor-pointer">
            <PhoneCall className="h-6 w-6" />
            <span className="lg:text-[1.5rem] font-montserrat font-medium">
              514-945-8852
            </span>
          </div>
        </div>

        {/* Navigation Links */}
        <nav className="flex w-full flex-wrap gap-8 lg:w-auto">
          {/* Services Links */}
          <ul className="flex w-[50%] max-w-[175px] flex-col gap-4 lg:w-auto">
            <li>
              <span className="mb-2 block text-base font-bold text-foreground">
                Quick pages
              </span>
            </li>
            {services.map((item, index) => (
              <li key={index}>
                <a
                  href={item[1]}
                  className="relative text-sm text-foreground/80 opacity-80 transition-colors hover:text-primary after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-current after:transition-all hover:after:w-full"
                >
                  <span>{item[0]}</span>
                </a>
              </li>
            ))}
          </ul>

          {/* About Links */}
          <ul className="flex w-[50%] max-w-[175px] flex-col gap-4 lg:w-auto">
            <li>
              <span className="mb-2 block text-base font-bold text-foreground">
                Socials
              </span>
            </li>
            {about.map((item, index) => (
              <li key={index}>
                <a
                  href={item[1]}
                  className="relative flex items-center gap-2 text-sm text-foreground/80 opacity-80 transition-colors hover:text-primary after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-current after:transition-all hover:after:w-full"
                >
                  {socialIndexes.includes(index) ? getSocialIcon(index) : null}
                  <span>{item[0]}</span>
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      {/* Bottom Section */}
      <div className="mx-auto mt-12 flex flex-wrap justify-center gap-6 border-t border-border pt-8 text-sm text-foreground/80 lg:mt-16 lg:flex-nowrap lg:justify-start lg:gap-9">
        <div className="flex justify-center w-full">
          <span className="w-full max-w-7xl text-center opacity-80 lg:text-left">
            Copyright© 2025{" "}
            <a href="/" className="transition-colors hover:text-secondary">
              Bishop Mercier
            </a>{" "}
          </span>
        </div>
      </div>
    </footer>
  );
}
